<div *ngIf="mapLoading" class="widget-loader">
  <mat-spinner></mat-spinner>
</div>
<div #mapViewNode [style.height]="height+'px'" [style.visibility]="mapLoading ? 'hidden' : 'visible'">
  <kendo-colorpicker
    *ngIf="!readonlyMode"
    id="pgmDialogEditColorPickerComponent"
    class="esri-widget esri-widget--button esri-interactive"
    view="gradient"
    matTooltip="Choisir la couleur de remplissage d'un polygon"
    (valueChange)="colorChange($event)"
    [value]="selectedColor">
  </kendo-colorpicker>
</div>
